class FilterToggle extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest("div[data-section-id]");
    this.button = this.querySelector("button");
  }

  connectedCallback() {
    if (!this.section) return;
    this.container = this.closest(".collection__container") || this.section.querySelector(".collection__container");
    
    if (!this.container || !this.button) return;

    this.button.addEventListener("click", () => this.toggleFilters());
  }

  toggleFilters() {
    if (!this.container) return;
    const isHidden = this.container.classList.contains("filters-hidden");
    this.setFiltersHidden(!isHidden);
  }

  setFiltersHidden(hide) {
    if (!this.container) return;
    if (hide) {
      this.container.classList.add("filters-hidden");
      localStorage.setItem("collection-filters-hidden", "true");
    } else {
      this.container.classList.remove("filters-hidden");
      localStorage.setItem("collection-filters-hidden", "false");
    }
  }
}

customElements.define("filter-toggle", FilterToggle);
